import { APP_SIZES } from "Common/componentUtils/constants";
import includes from "lodash/includes";
import styled, { css } from "styled-components";
import { NAV_CENTERED_CONTENT_CLASS_NAME, NAV_ITEM_ACTIVE_CLASS_NAME, NAV_ITEM_CLASS_NAME, NAV_ITEM_DISABLED_CLASS_NAME, NAV_ITEM_HAS_SUB_ITEMS_CLASS_NAME, NAV_ITEM_SELECTED_CLASS_NAME, NAV_MB_DEFAULT_GAP_CLASS_NAME } from "../../constants";
export const SIZES = {
    MIN_ITEM_HEIGHT: 40,
    ITEMS_GAP: 8,
    BTN_MARGIN_BOTTOM: 12
};
const navLink = (selector, color, bg, iconColor = undefined, fontWeight = undefined) => css `
  ${selector} {
    &,
    &:active,
    &:focus,
    &:visited {
      min-height: ${SIZES.MIN_ITEM_HEIGHT}px;
      text-align: left;
      text-decoration: none;
      ${({ theme }) => color && `color: ${theme[color]}`};
      ${({ theme }) => bg && `background-color: ${theme[bg] || bg}`};
      ${fontWeight && `font-weight: ${fontWeight};`};
      border-radius: ${({ theme }) => theme["border-radius-medium"]};
      cursor: pointer;

      ${({ theme }) => ((iconColor && theme[iconColor]) || bg) &&
    `.dx-icon { color: ${(iconColor && theme[iconColor]) || bg}; }`};
    }
  }
`;
const buildNavLinksStyles = (colorDefault, colorHover, colorActive, bgColorDefault, bgColorActive, bgColorHover, smallMargins) => css `
  .${NAV_CENTERED_CONTENT_CLASS_NAME} {
    grid-template-columns: auto auto;
    justify-content: center;
  }

  .${NAV_MB_DEFAULT_GAP_CLASS_NAME} {
    margin-bottom: ${SIZES.BTN_MARGIN_BOTTOM}px;
  }

  .${NAV_ITEM_HAS_SUB_ITEMS_CLASS_NAME} + div {
    ${({ theme }) => `border-left: ${theme["sidebar-nav-item-group-border-left"]};`}
    margin-left:  ${({ theme }) => theme[smallMargins ? "padding-xxxs" : "sidebar-nav-item-group-margin-left"]};
    padding-left: ${({ theme }) => theme[smallMargins ? "padding-xxxs" : "sidebar-nav-item-group-padding-left"]};
  }

  ${navLink(`.${NAV_ITEM_CLASS_NAME}`, colorDefault, bgColorDefault)}

  ${navLink(`.${NAV_ITEM_CLASS_NAME}.${NAV_ITEM_DISABLED_CLASS_NAME}`, "gray-400", bgColorDefault)}

  ${navLink(`.${NAV_ITEM_CLASS_NAME}:not(.${NAV_ITEM_DISABLED_CLASS_NAME}):hover`, colorHover, bgColorHover)}

  ${navLink(`.${NAV_ITEM_CLASS_NAME}.${NAV_ITEM_SELECTED_CLASS_NAME}:not(.${NAV_ITEM_DISABLED_CLASS_NAME})`, colorDefault, bgColorDefault, colorActive, "600")}

  ${navLink(`.${NAV_ITEM_CLASS_NAME}.${NAV_ITEM_ACTIVE_CLASS_NAME}:not(.${NAV_ITEM_DISABLED_CLASS_NAME})`, colorActive, bgColorActive, colorActive, "600")}

  ${navLink(`.${NAV_ITEM_CLASS_NAME}.${NAV_ITEM_SELECTED_CLASS_NAME}:not(.${NAV_ITEM_DISABLED_CLASS_NAME}):hover`, "", bgColorActive)}
`;
export default {
    LogoContainer: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["sidebarWidth"], prop)
    }) `
    max-width: ${({ sidebarWidth }) => sidebarWidth}px;
    display: grid;
    align-items: center;
    gap: 16px;
    padding: 16px 12px;
    border-bottom: 1px solid ${({ theme }) => theme["navbar-divider-color"]};
    z-index: ${({ theme }) => theme["zindex-navbar-fixed"]};
    > img {
      height: ${APP_SIZES.LOGO_HEIGHT}px;
    }
  `,
    NavItemsContainer: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes([
            "colorDefault",
            "colorHover",
            "colorActive",
            "bgColorDefault",
            "bgColorActive",
            "smallMargins",
            "bgColorHover"
        ], prop)
    }) `
    ${({ colorDefault, colorHover, colorActive, bgColorDefault, bgColorActive, bgColorHover, smallMargins }) => buildNavLinksStyles(colorDefault, colorHover, colorActive, bgColorDefault, bgColorActive, bgColorHover, smallMargins)}

    > .${NAV_ITEM_CLASS_NAME} {
      margin-bottom: ${SIZES.ITEMS_GAP}px;
    }

    .virtual-row {
      padding-bottom: ${SIZES.ITEMS_GAP}px;
      color: ${({ theme, colorDefault }) => theme[colorDefault || "navbar-link-color"]};
    }
  `
};
